import { hotComments } from '@/mocks/articles';

export default function HotComments() {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
      <div className="text-center mb-12">
        <div className="flex items-center justify-center space-x-2 mb-4">
          <div className="w-5 h-5 rounded-sm bg-red-500 rotate-45 flex items-center justify-center">
            <span className="w-2 h-2 bg-background-50 rounded-sm -rotate-45"></span>
          </div>
          <span className="text-primary-400 text-xs font-medium tracking-wider">实时热议</span>
        </div>
        <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-50 mb-2">
          网友<strong className="text-primary-400">吃瓜热议</strong>
        </h2>
        <p className="text-foreground-500 text-sm">最真实的吃瓜群众声音，热评精选</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {hotComments.slice(0, 5).map((comment, index) => (
          <div
            key={comment.id}
            className={`bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-primary-500/20 transition-colors ${
              index === 2 ? 'md:col-span-1' : ''
            } ${index === 3 ? 'md:col-span-2' : ''}`}
          >
            <div className="flex items-start space-x-3 mb-4">
              <img
                src={comment.avatar}
                alt={comment.username}
                className="w-10 h-10 rounded-full object-cover flex-shrink-0"
              />
              <div>
                <p className="text-foreground-200 text-sm font-medium">{comment.username}</p>
                <p className="text-foreground-600 text-xs">{comment.time}</p>
              </div>
            </div>
            <div className="relative mb-3">
              <i className="ri-double-quotes-l text-3xl text-primary-500/20 absolute -top-1 -left-1"></i>
              <p className="text-foreground-300 text-sm leading-relaxed pl-6">
                {comment.content}
              </p>
            </div>
            <div className="flex items-center space-x-1 text-foreground-500 text-xs">
              <i className="ri-thumb-up-line w-3 h-3 flex items-center justify-center"></i>
              <span>{comment.likes >= 1000 ? `${(comment.likes / 1000).toFixed(0)}k` : comment.likes}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}